<template>
    <div id="app" v-bind:class="{'is-android': isAndroid}">
        <div v-if="isNotFounded">
            <not-found-page></not-found-page>
        </div>
        <div v-else-if="isI18nLoaded">
            <ob-mobile-menu></ob-mobile-menu>
            <ob-header></ob-header>
            <router-view/>
            <ob-footer></ob-footer>
            <download-app v-if="isMobile()"></download-app>
        </div>
        <div v-else-if="isI18nErrored">Something went wrong...</div>
        <div v-else>Loading...</div>
    </div>
</template>

<style lang="scss">
 #app{
     overflow: hidden;
 }
</style>

<script>
    import obFooter from './components/footer/footer.vue';
    import obHeader from './components/header/header.vue';
    import obMobileMenu from './components/mobile-menu.vue';
    import notFoundPage from "./components/404"
    import downloadApp from "./components/download-app/download-app"

    export default {
        data() {
            return {
                isAndroid: false
            }
        },
        methods: {
            isMobile() {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            },
        },
        mounted() {
            if (navigator.userAgent.match(/Android/i)) {
                this.isAndroid = true;
            }
        },
        components: {
            obMobileMenu,
            obFooter,
            obHeader,
            notFoundPage,
            downloadApp
        },
        computed: {
            isI18nLoaded() {
                return this.$store.getters.isI18nLoaded;
            },
            isI18nErrored() {
                return this.$store.getters.isI18nErrored;
            },
            isNotFounded() {
                return this.$store.getters.notFoundState;
            }
        }
    }
</script>
